import React, { useEffect } from 'react';
import { LandingNav } from '../components/landing/LandingNav';
import { HeroSection } from '../components/landing/HeroSection';
import { LeaksGrid } from '../components/landing/LeaksGrid';
import { ReportPreviews } from '../components/landing/ReportPreviews';
import { WhyEpicurea } from '../components/landing/WhyEpicurea';
// CaseStudies temporarily hidden by user request — keep the import commented for fast re-enable.
// import { CaseStudies } from '../components/landing/CaseStudies';
import { ImpactNumbers } from '../components/landing/ImpactNumbers';
import { EngagementProcess } from '../components/landing/EngagementProcess';
import { FAQ } from '../components/landing/FAQ';
import { ContactCTA, Footer } from '../components/landing/ContactCTA';
import { LiveTicker } from '../components/landing/LiveTicker';
import { usePageMeta } from '../hooks/usePageMeta';

export const Landing = () => {
  usePageMeta({
    title: 'Epicurea Nexus — Financial Clarity for the Modern Restaurant',
    description: 'An in-house finance practice for restaurants. Weekly briefings and monthly reads with deterministic numbers, plain-English narratives, and quiet recovery in the background.',
  });
  useEffect(() => {
    document.title = 'Epicurea Nexus — Restaurant financials, read like a briefing.';
    const prevBg = document.body.style.backgroundColor;
    document.body.style.backgroundColor = '#28282B';
    return () => { document.body.style.backgroundColor = prevBg; };
  }, []);

  return (
    <div id="top" data-landing-page="true" className="relative min-h-screen text-white antialiased overflow-x-hidden" style={{ backgroundColor: '#28282B' }} data-testid="landing-page">
      {/* Global noise/grain overlay for film texture */}
      <div
        aria-hidden="true"
        className="pointer-events-none fixed inset-0 opacity-[0.025] mix-blend-overlay z-[1]"
        style={{
          backgroundImage: "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)' opacity='0.85'/%3E%3C/svg%3E\")",
        }}
      />

      <LandingNav />
      <main className="relative z-[2]">
        <HeroSection />
        <LiveTicker />
        <LeaksGrid />
        <ReportPreviews />
        <WhyEpicurea />
        <ImpactNumbers />
        <EngagementProcess />
        {/* <CaseStudies />  ← hidden by user request; re-enable when ready */}
        <FAQ />
        <ContactCTA />
      </main>
      <Footer />
    </div>
  );
};

export default Landing;
